import { MouseEvent, useEffect } from 'react';
import Image from 'global/Image';

import {
  clevertapDayTradeActivationViewed,
  clevertapDayTradeActivationSelected,
  clevertapDayTradeActivationDismissed,
} from 'lib/analytics/securities';

import BaseSecuritiesModal from 'global/Securities/components/Modal/BaseSecuritiesModal';
import type { BaseSecuritiesModalProps } from 'global/Securities/components/Modal/BaseSecuritiesModal';

import {
  ActionWrapper,
  CancelButton,
  Container,
  ContentWrapper,
  Description,
  NextButton,
  Title,
} from './onboarding.styled';

const DayTradeOnboarding = ({
  onCancel = () => {},
  onSubmit = () => {},
  ...props
}: BaseSecuritiesModalProps) => {
  const handleSubmit = () => {
    onSubmit();
    clevertapDayTradeActivationSelected();
  };

  const handleCancel = (e: MouseEvent<HTMLElement>) => {
    onCancel(e);
    clevertapDayTradeActivationDismissed();
  };

  useEffect(() => {
    clevertapDayTradeActivationViewed();
  }, []);

  return (
    <BaseSecuritiesModal hideSubmit onCancel={handleCancel} {...props}>
      <Container>
        <Image
          src="/images/day-trade/onboarding.svg"
          alt="Day Trade Onboarding"
        />

        <ContentWrapper>
          <Title>Day Trade</Title>
          <Description>
            Tingkatkan daya beli hingga 5 kali lipat trading balance kamu dengan
            fitur Day Trade.
          </Description>
        </ContentWrapper>

        <ActionWrapper>
          <NextButton onClick={handleSubmit} type="primary">
            Aktifkan Sekarang
          </NextButton>
          <CancelButton onClick={handleCancel}>Nanti Aja</CancelButton>
        </ActionWrapper>
      </Container>
    </BaseSecuritiesModal>
  );
};

export default DayTradeOnboarding;
